import n from "moment";
import m from "./getOutletNextOpeningTagInformation.mjs";
import "@ancon/wildcat-types";
import "./getOutletTagInformation.mjs";
import "../date/createLocalTimezoneMoment.mjs";
import "./constants.mjs";
import "./getOutletCurrentActiveOperatingHour.mjs";
import "./getTimezoneAdjustedServiceInterval.mjs";
import "../time/getTimeSpanParts.mjs";
import "../date/getTimezoneUtcOffsetDifference.mjs";
import "../date/convertToSpecificTimezone.mjs";
import "./getServiceIntervalTimeSpanMoment.mjs";
import "./searchNextOpeningMoment.mjs";
function y(o, e) {
  const t = m(o);
  if (t && !t.openNow && t.openingTime) {
    const i = n(t.openingTime).calendar({
      sameDay: "[Today] [at] LT",
      nextDay: "[Tomorrow] [at] LT",
      nextWeek: "ddd [at] LT"
    });
    return e("openingTime", {
      time: i
    });
  }
  return null;
}
export {
  y as default
};
